module.exports = __webpack_public_path__ + "assets/media/1.993f95d9.wav";